import type { Matcher } from "./index";
import { extractNegation, isCurrentNegated } from "./negation-extractor";

export const deviceMatcher = (_currentDevice?: string): Matcher => {
  const currentDevice = _currentDevice?.toLowerCase();
  return (group) => {
    const devices = group.d ?? group.devices ?? [];
    const deviceObjects = devices.map((device) =>
      extractNegation(device.toLowerCase()),
    );

    if (deviceObjects.length === 0) {
      return true;
    }

    if (!currentDevice) {
      return true; // FIXME: na pewno? unit test
    }

    if (isCurrentNegated(currentDevice, deviceObjects)) {
      return false;
    }

    return deviceObjects.some(
      (object) => (object.value === currentDevice) !== object.negated,
    );
  };
};
